/* ==============================================================================================
 * [ACCESS] LEI SEARCH RESULTS TABLE
 * ============================================================================================== */

var Sushi, CGS;

(function (Sushi, CGS) {
	"use strict";

	var apiEndpoint = "/json/access/leiSearchResults.json";
	var tableElement = document.querySelector("#leiSearchResultsTable");

	if (!tableElement) {
		return;
	}

	CGS.table(tableElement, {
		files: true,
		ajax: apiEndpoint,
		columns: [
			{
				data: null,
				orderable: false,
				className: "c-table__cell c-table__cell--checkbox",
			},
			{
				data: null,
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "lei",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "mainCusip",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "secondaryCusip",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "mutualFund",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "legalName",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "domicile",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "state",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "status",
				className: "c-table__cell",
				searchable: true,
			},
		],
		columnDefs: [
			{
				targets: [ 0 ],
				render: function (data) {
					return CGS.renderFileExportCheckCell(data.cabre);
				},
			},
			{
				targets: [ 1 ],
				render: function (data) {
					return "<a data-plugin='CabreDetail' "
						+ "href='#' "
						+ "data-cabre='" + data.cabre + "' "
                        + "data-issuer-number='" + data.mainCusip + "' "
						+ ">" + data.cabre + "</a>";
				},
			},
		],
		initComplete: CGS.createRetractTableWrapper,
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
